var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLine2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 197,
  height: 5,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#F4C341",
  strokeLinecap: "round",
  strokeOpacity: 0.3,
  strokeWidth: 4,
  d: "M32 2.5H2M194.5 3h-30"
})));
export { SvgLine2 as ReactComponent };
export default __webpack_public_path__ + "1e2b966a9e05b8ee60675112ed284362.svg";